mutation NoteCardHolderCreate($input: NoteCardHolderCreateInput!) {
  noteCardHolderCreate(input: $input) {
    note {
      id
      noteComment
      _rowTimestamp
      isShared
      entityId
    }
  }
}